import api from 'api';

export const loadSpendAdjustmentTable = api('POST /api/spend-adjustments/grid');

export const loadActionsLogs = api('GET /api/spend-adjustments/:id/logs');

export const createSpendAdjustment = api('POST /api/spend-adjustments');

export const checkSpendAdjustment = api(
  'POST /api/spend-adjustments/checkIntegration'
);

export const importSA = api('POST /api/spend-adjustments/import');

export const importSAByCampaigns = api(
  'POST /api/spend-adjustments/import-by-campaigns'
);

export const updateSpendAdjustment = api('PUT /api/spend-adjustments/:id');
export const loadSpendAdjustmentDetails = api(
  'GET /api/spend-adjustments/:id/details'
);
export const loadSpendAdjustment = api('GET /api/spend-adjustments/:id');

export const deleteSpendAdjustment = api(
  'POST /api/spend-adjustments/:id/delete'
);
export const approveSpendAdjustment = api(
  'POST /api/spend-adjustments/:id/approve'
);
export const rejectSpendAdjustment = api(
  'POST /api/spend-adjustments/:id/reject'
);
export const moreInfoSpendAdjustment = api(
  'POST /api/spend-adjustments/:id/more-info'
);
export const undoSpendAdjustment = api('POST /api/spend-adjustments/:id/undo');
export const exportGrid = api('GET /api/spend-adjustments/export', {
  responseType: 'blob',
});
